// extracted by mini-css-extract-plugin
export default {"table":"ResultTemplate_table__ufGDO","colDiv":"ResultTemplate_colDiv__p+AEZ"};